<script setup lang="ts">
import { useDebounceFn } from "@vueuse/core";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import InputText from "primevue/inputtext";
import { useGetChatSessionCounts } from "@/providers/chatSessions/useGetChatSessionCounts";
import AnonymousAdvisingFilters from "./AnonymousAdvisingFilters/index.vue";
import AnonymousAdvisingHeader from "./AnonymousAdvisingHeader/index.vue";
import AnonymousAdvisingTable from "./AnonymousAdvisingTable/index.vue";
import { useSearchStringFilter } from "./composables/useSearchStringFilter";
import { anonymousAdvisingPresets } from "./styles";
import type { Props } from "./types";

defineOptions({
  name: "AnonymousAdvising",
});

const props = withDefaults(defineProps<Props>(), {});

const { searchString, updateSearchStringFilter } = useSearchStringFilter();

const debouncedSearchStringUpdate = useDebounceFn(
  (value?: string) => {
    updateSearchStringFilter(value);
  },
  1000,
  { maxWait: 5000 },
);

const { data: countsData, isPending: countsLoading } = useGetChatSessionCounts();
</script>

<template>
  <div class="mt-6 mx-6">
    <AnonymousAdvisingHeader
      :anonymous-count="countsData?.anonymous_count ?? 0"
      :non-anonymous-count="countsData?.non_anonymous_count ?? 0"
      :loading="countsLoading"
    />
    <div class="flex font-normal font-montserrat w-full mt-6 justify-end">
      <IconField iconPosition="left" class="w-2/4 pr-2">
        <InputIcon class="input-icon-position">
          <span class="material-symbols-outlined text-green-800 text-center text-3xl ml-4">search</span>
        </InputIcon>
        <InputText
          :pt="anonymousAdvisingPresets.inputtext"
          :model-value="searchString"
          placeholder="SEARCH"
          @update:modelValue="(value) => debouncedSearchStringUpdate(value)"
          class="ml-4 w-full block font-montserrat font-bold text-base text-university-primary leading-5 py-1 pr-1 border border-gray-475 rounded-full h-10 placeholder-university-primary bg-white"
        />
      </IconField>
    </div>
    <AnonymousAdvisingFilters />
    <AnonymousAdvisingTable />
  </div>
</template>

<style scoped>
.input-icon-position {
  top: 12px;
}
</style>
